import Image1 from '../../../assets/svg/correct-icon.svg?react';
import Image2 from '../../../assets/svg/wi.svg?react';
import CorrectIcon from '../../../assets/svg/image-111.svg?react';
import WrongIcon from '../../../assets/svg/wrong-111.svg?react';
import FJLocalStore from '../../../store/FJLocalStore.js';
import useLocalStore from '../../../hooks/useLocalStore.js';
import styles from './FJTipsContent.module.less';
import classNames from 'classnames';
import FJClothesChangerConfig from '../../../config/appConfig/FJClothesChangerConfig.js';
import FJTipsHeaderClass from './FJTipsHeader.class.jsx';

const Content = props => {
    const { imageList = [], textList = [], icon } = props;
    return (
        <div className={styles.content_box}>
            <div className={styles.image_list}>
                {imageList.map((url, index) => {
                    return (
                        <div className={styles.image_item} key={index}>
                            <img src={url} />
                        </div>
                    );
                })}
            </div>
            <div className={styles.text_list}>
                {textList.map((text, index) => {
                    return (
                        <div className={styles.text_item} key={index}>
                            {icon}
                            <span>{FJLocalStore._(text)}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const IMAGE_LIST1 = [
    `${FJClothesChangerConfig.tipsImagePath}image-1.png`,
    `${FJClothesChangerConfig.tipsImagePath}image-2.png`,
    `${FJClothesChangerConfig.tipsImagePath}image-3.png`,
    `${FJClothesChangerConfig.tipsImagePath}image-4.png`,
];
const TEXT_LIST1 = ['cc-tips-1', 'cc-tips-2', 'cc-tips-3', 'cc-tips-4'];

const IMAGE_LIST2 = [
    `${FJClothesChangerConfig.tipsImagePath}wrong1.png`,
    `${FJClothesChangerConfig.tipsImagePath}wrong2.png`,
    `${FJClothesChangerConfig.tipsImagePath}wrong3.png`,
    `${FJClothesChangerConfig.tipsImagePath}wrong4.png`,
];
const TEXT_LIST2 = ['cc-wrong-1', 'cc-wrong-2', 'cc-wrong-3', 'cc-wrong-4'];

const header1 = new FJTipsHeaderClass({
    image: <Image1 />,
    text: 'correct',
});

const header2 = new FJTipsHeaderClass({
    image: <Image2 />,
    text: 'wrong',
});

const FJTipsContent = () => {
    useLocalStore();

    return (
        <div className={classNames(styles.box)}>
            {header1.render({ className: classNames(styles.header, styles.correct) })}
            <Content imageList={IMAGE_LIST1} textList={TEXT_LIST1} icon={<CorrectIcon />} />

            {header2.render({ className: classNames(styles.header, styles.wrong) })}
            <Content imageList={IMAGE_LIST2} textList={TEXT_LIST2} icon={<WrongIcon />} />
        </div>
    );
};

export default FJTipsContent;
